import { inject, Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { ApiLegalDocuments } from './api-legal-documents';
import { ApiLegalDocumentsHttpService } from './api-legal-documents-http.service';

@Injectable({
  providedIn: 'root',
})
export class ApiLegalDocumentsCacheService {
  protected httpService = inject(ApiLegalDocumentsHttpService);

  protected readonly cacheSubject = new ReplaySubject<ApiLegalDocuments>(1);

  public preloadDocuments(): Subscription {
    return this.httpService.getDocuments().subscribe(this.cacheSubject);
  }

  public getDocuments(): Observable<ApiLegalDocuments> {
    return this.cacheSubject.asObservable();
  }
}
